import companyInfo from "../../../../model/constants/companyInfo";
import { removePermissions, removeToken, removeUserDetails } from "@/utils/auth";
import { logSelfServiceManualEvent, SelfServiceEventType } from "@/utils/selfServiceSessionTelemetry";
export default {
  data() {
    return {
      numbers: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
      PIN: "",
      passMask: "####",
      logo: companyInfo.logo,
      /** Yalnızca Kapat / başarılı PIN ile kapanışa izin ver (backdrop tıklamasını yok say) */
      pinCloseAllowed: false,
    };
  },
  methods: {
    onPinPopupUpdateActive(val) {
      if (val) {
        this.$store.dispatch("selfservice/setPinEntryOpen", true);
        return;
      }
      if (this.pinCloseAllowed) {
        this.pinCloseAllowed = false;
        this.$store.dispatch("selfservice/setPinEntryOpen", false);
        return;
      }
      this.$nextTick(() => {
        this.$store.dispatch("selfservice/setPinEntryOpen", true);
      });
    },
    /** Üst oturum (gerçek login) şube yöneticisi/yatırımcısıysa ve girilen PIN bir barista'ya aitse true.
     * Bu durumda barista'yı yöneticinin yetkili oturumu altında aktif personel yapmak güvenlik açığı
     * olur — barista kendi hesabıyla ayrı giriş yapmalı, o yüzden tüm oturum kapatılır. */
    isManagerSessionWithBaristaPin(targetPerson) {
      const loggedInUser = this.$store.getters["getActiveUser"];
      const loggedInIsManagerOrInvestor =
        loggedInUser &&
        loggedInUser.role &&
        loggedInUser.role.some((r) => r.name === "Şube Yöneticisi" || r.name === "Şube Yatırımcısı");
      if (!loggedInIsManagerOrInvestor) return false;
      return !!(
        targetPerson.role &&
        targetPerson.role.some((r) => r.name && r.name.toLowerCase() === "barista")
      );
    },
    forceLogoutToMainLogin(message) {
      this.PIN = "";
      this.$vs.notify({
        color: "warning",
        title: "Oturum Sonlandırıldı",
        text: message,
      });
      try {
        if (localStorage.getItem("auth-token")) {
          localStorage.removeItem("auth-token");
        }
        removePermissions();
        removeUserDetails();
        removeToken();
        localStorage.removeItem("selfservice_carts");
        localStorage.removeItem("selfservice_payment_session");
        sessionStorage.removeItem("selfservice_locked");
      } catch (e) {
        console.error(e);
      }
      this.$router.push("/pages/login").catch(() => {});
    },
    checkForPin(val) {
      let personList = this.$store.getters["selfservice/getPersonList"];
      let currentPerson = personList.find((x) => x.userCode === val);
      if (currentPerson) {
        if (this.isManagerSessionWithBaristaPin(currentPerson)) {
          this.forceLogoutToMainLogin(
            "Yönetici/Yatırımcı oturumunda barista girişi yapılamaz. Lütfen barista kendi hesabıyla giriş yapsın."
          );
          return;
        }
        this.pinCloseAllowed = true;
        this.$store.dispatch("selfservice/setActivePersonal", currentPerson);
        logSelfServiceManualEvent(SelfServiceEventType.ScreenUnlocked, {
          personalId: currentPerson.id,
          name: [currentPerson.name, currentPerson.surname].filter(Boolean).join(" ")
        });
        this.$store.dispatch("selfservice/setPinEntryOpen", false);
        this.$store.dispatch("selfservice/setScreenLock", false);
        try {
          sessionStorage.removeItem('selfservice_locked');
        } catch (e) {
          console.error(e);
        }
        this.PIN = "";
        this.$vs.notify({
          color: "success",
          title: "Giriş Başarılı !",
          text: " Satışa Hazır !",
        });
      } else {
        this.$vs.notify({
          color: "danger",
          title: "PIN BULUNAMADI !",
          text: "Lütfen Doğru PIN Giriniz.",
        });
        this.PIN = "";
      }
    },
    focusInput() {

      this.$refs.txtPassword.focus();
    },
  },
  watch: {
    PIN(val) {
      if (val.length == 4) {
        this.checkForPin(val);
      }
    },
    pinEntryOpen(val) {
      if (val) {
        this.pinCloseAllowed = false;
        this.$nextTick(() => {
          this.focusInput();
        });
      }
    },
  },
  computed: {
    pinEntryOpen() {
      return this.$store.getters["selfservice/getPinEntryOpen"];
    },
  },
  created() {
    this.PIN = "";
  },
};
